/* Bozetto tavelväggsbyggare
 * ---------------------------------------------------------------------------
 * Ingen canvas, inga bibliotek. Absolut positionerade element och CSS.
 *
 * ALLA POSITIONER ÄR I CENTIMETER från väggens mitt. Scenen räknas om till
 * px vid varje rendering. Det gör modellen enhetsoberoende: samma vägg kan
 * ritas i valfri storlek, och totalmåttet går att räkna ut.
 *
 * Varje ruta bär sin egen storlek och sin egen ram. Väggfärgen ligger alltid
 * under rumsbilden, som har väggytan urtagen — därför går färgen att byta
 * även när ett rum är valt.
 */
(function () {
  'use strict';

  var CFG = null;
  var el = {};
  var S = {
    room: null,       // index i CFG.rooms, null = ingen rumsbild
    color: 0,         // index i CFG.wallColors, alltid satt
    slots: [],        // {id, w, h, x, y, product, variantId, frame}
    lastFrame: null,  // ramen nya rutor får
    category: null,   // senast använda kategori, så nästa ruta öppnar i samma
    framing: null,    // null = inte tillfrågad än, annars true/false
    wallId: null,
  };

  var SNAP_CM = 1.6;      // snäpptolerans
  var FRAME_CM = 2;       // ramlistens bredd i cm
  var LAGER = 'bozetto-gwb-v2';
  var RESERV = [{ w: 21, h: 30 }, { w: 30, h: 40 }, { w: 40, h: 50 },
                { w: 50, h: 70 }, { w: 70, h: 100 }];

  /* ---------------------------------------------------------------- hjälp */

  function kr(ore) {
    return (ore / 100).toLocaleString('sv-SE', {
      style: 'currency', currency: CFG.currency, maximumFractionDigits: 0
    });
  }

  function sizeLabel(w, h) { return w + '×' + h + ' cm'; }
  function sizeKey(w, h) { return w + 'x' + h; }

  function ppc() { return el.stage.clientWidth / CFG.wallWidthCm; }

  function uid() { return 's' + Math.random().toString(36).slice(2, 9); }

  function el_(tag, kl, text) {
    var n = document.createElement(tag);
    if (kl) n.className = kl;
    if (text != null) n.textContent = text;
    return n;
  }

  // Storlekarna kommer ur ramarnas egna varianter, inte ur en lista i koden.
  // Då går det aldrig att välja en storlek som inte finns att rama in.
  // Kvadratiska format hoppas över — de ska inte erbjudas i byggaren.
  function storlekar() {
    var sedda = {};
    Object.keys(CFG.frames).forEach(function (k) {
      Object.keys(CFG.frames[k].variants || {}).forEach(function (nyckel) {
        var m = String(nyckel).match(/(\d+)\s*x\s*(\d+)/);
        if (m && m[1] !== m[2]) sedda[m[1] + 'x' + m[2]] = { w: +m[1], h: +m[2] };
      });
    });
    var lista = Object.keys(sedda).map(function (k) { return sedda[k]; });
    if (!lista.length) return RESERV.slice();
    lista.sort(function (a, b) { return a.w * a.h - b.w * b.h; });
    return lista;
  }

  /* ------------------------------------------------------------ rendering */

  function visaGrupp(nod, finns) {
    var g = nod.closest('.gwb__group');
    if (g) g.hidden = !finns;
  }

  function renderRooms() {
    visaGrupp(el.rooms, CFG.rooms.length > 0);
    el.rooms.innerHTML = '';

    // Första valet är ingen rumsbild alls — bara den valda väggfärgen.
    var tom = el_('button', 'gwb__opt' + (S.room == null ? ' is-active' : ''));
    tom.type = 'button';
    var sw = el_('span', 'gwb__swatch');
    sw.style.background = aktivFarg();
    tom.appendChild(sw);
    tom.appendChild(el_('span', 'gwb__optlabel', 'Bara vägg'));
    tom.addEventListener('click', function () {
      S.room = null; renderRooms(); paintRoom(); save();
    });
    el.rooms.appendChild(tom);

    CFG.rooms.forEach(function (r, i) {
      var b = el_('button', 'gwb__opt' + (i === S.room ? ' is-active' : ''));
      b.type = 'button';
      b.setAttribute('aria-pressed', String(i === S.room));
      var im = document.createElement('img');
      im.src = r.thumb || r.img; im.alt = ''; im.loading = 'lazy';
      b.appendChild(im);
      b.appendChild(el_('span', 'gwb__optlabel', r.name));
      b.addEventListener('click', function () {
        S.room = i; renderRooms(); paintRoom(); save();
      });
      el.rooms.appendChild(b);
    });
  }

  function aktivFarg() {
    var c = CFG.wallColors[S.color];
    return c ? c.color : '#efeae3';
  }

  function renderColors() {
    visaGrupp(el.colors, CFG.wallColors.length > 0);
    el.colors.innerHTML = '';
    CFG.wallColors.forEach(function (c, i) {
      var b = el_('button', 'gwb__opt' + (S.color === i ? ' is-active' : ''));
      b.type = 'button';
      b.setAttribute('aria-pressed', String(S.color === i));
      b.title = c.name;
      var sw = el_('span', 'gwb__swatch');
      sw.style.background = c.color;
      b.appendChild(sw);
      b.appendChild(el_('span', 'gwb__optlabel', c.name));
      b.addEventListener('click', function () {
        S.color = i;
        renderColors(); renderRooms(); paintRoom(); save();
      });
      el.colors.appendChild(b);
    });
  }

  // Väggfärgen är alltid bakgrundsfärg. Rumsbilden läggs ovanpå och har
  // väggytan urtagen, så färgen lyser igenom just där väggen är.
  function paintRoom() {
    el.stage.style.backgroundColor = aktivFarg();
    // Glaset speglar rummet svagt. Utan den tonen ser trycket ut som en bild
    // pa en skarm i stallet for nagot bakom glas.
    el.root.style.setProperty('--gwb-rum', aktivFarg());
    var r = S.room != null ? CFG.rooms[S.room] : null;
    if (r && r.img) {
      el.stage.style.backgroundImage = 'url("' + r.img + '")';
      el.wall.style.left = (r.cx != null ? r.cx : 0.5) * 100 + '%';
      el.wall.style.top = (r.cy != null ? r.cy : 0.42) * 100 + '%';
    } else {
      el.stage.style.backgroundImage = 'none';
      el.wall.style.left = '50%';
      el.wall.style.top = '46%';
    }
  }

  function clampToStage(slot) {
    var m = ppc();
    var ox = el.wall.offsetLeft, oy = el.wall.offsetTop;
    var minX = -ox / m + slot.w / 2, maxX = (el.stage.clientWidth - ox) / m - slot.w / 2;
    var minY = -oy / m + slot.h / 2, maxY = (el.stage.clientHeight - oy) / m - slot.h / 2;
    if (minX <= maxX) slot.x = Math.min(maxX, Math.max(minX, slot.x));
    if (minY <= maxY) slot.y = Math.min(maxY, Math.max(minY, slot.y));
    return slot;
  }

  function tacker(a, b) {
    var dx = Math.abs(a.x - b.x) - (a.w + b.w) / 2;
    var dy = Math.abs(a.y - b.y) - (a.h + b.h) / 2;
    if (dx >= 0 || dy >= 0) return 0;
    return (-dx * -dy) / (a.w * a.h);
  }

  function stageHoger() {
    return (el.stage.clientWidth - el.wall.offsetLeft) / ppc();
  }

  function nyPlats(sz, gap) {
    if (!S.slots.length) return { x: 0, y: 0 };

    var maxY = Math.max.apply(null, S.slots.map(function (s) { return s.y; }));
    var rad = S.slots.filter(function (s) { return Math.abs(s.y - maxY) < 1; });
    var hoger = Math.max.apply(null, rad.map(function (s) { return s.x + s.w / 2; }));

    var onskad = hoger + gap + sz.w / 2;
    var p = clampToStage({ w: sz.w, h: sz.h, x: onskad, y: maxY });
    if (Math.abs(p.x - onskad) < 0.5) return p;

    var botten = Math.max.apply(null, rad.map(function (s) { return s.y + s.h / 2; }));
    var vanster = Math.min.apply(null, S.slots.map(function (s) { return s.x - s.w / 2; }));
    p = clampToStage({ w: sz.w, h: sz.h, x: vanster + sz.w / 2, y: botten + gap + sz.h / 2 });

    for (var i = 0; i < 24; i++) {
      var varst = 0;
      S.slots.forEach(function (s) { varst = Math.max(varst, tacker(p, s)); });
      if (varst < 0.5) break;
      p.x += gap + sz.w / 3;
      clampToStage(p);
      if (p.x + sz.w / 2 >= stageHoger() - 0.5) { p.x = vanster + sz.w / 2; p.y += sz.h / 3; clampToStage(p); }
    }
    return p;
  }

  function extent(slots) {
    var minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
    slots.forEach(function (s) {
      minX = Math.min(minX, s.x - s.w / 2); maxX = Math.max(maxX, s.x + s.w / 2);
      minY = Math.min(minY, s.y - s.h / 2); maxY = Math.max(maxY, s.y + s.h / 2);
    });
    return { w: maxX - minX, h: maxY - minY };
  }

  function startWall() {
    S.slots = CFG.startSlots.map(function (s) {
      return { id: uid(), w: s.w, h: s.h, x: s.x, y: s.y, product: null, variantId: null, frame: null };
    });
    renderWall();
    save();
  }

  function renderWall() {
    el.wall.innerHTML = '';
    var m = ppc();
    S.slots.forEach(function (slot) { el.wall.appendChild(buildFrame(slot, m)); });
    updateSummary();
  }

  function buildFrame(slot, m) {
    var f = el_('div', 'gwb-f');
    f.dataset.id = slot.id;
    f.setAttribute('role', 'button');
    f.tabIndex = 0;
    f.setAttribute('aria-label', slot.product
      ? slot.product.title + ', ' + sizeLabel(slot.w, slot.h)
      : 'Välj konstverk, ' + sizeLabel(slot.w, slot.h));

    var fw = slot.w * m, fh = slot.h * m;
    // Texten i den tomma rutan skalas med rutan.
    f.style.setProperty('--gwb-f-txt', Math.max(9, Math.min(13, fw * 0.16)) + 'px');
    var delStorlek = Math.max(15, Math.min(22, fw * 0.21));
    f.style.setProperty('--gwb-f-del', delStorlek + 'px');
    f.style.setProperty('--gwb-f-pad', Math.max(3, delStorlek * 0.26) + 'px');
    if (fw < 46) f.classList.add('gwb-f--xs');
    else if (fw < 84) f.classList.add('gwb-f--sm');
    f.style.width = fw + 'px';
    f.style.height = fh + 'px';
    f.style.left = (slot.x * m) + 'px';
    f.style.top = (slot.y * m) + 'px';

    var fr = slot.frame && CFG.frames[slot.frame];
    if (fr) {
      var bw = Math.max(1, FRAME_CM * m);
      f.style.borderStyle = 'solid';
      f.style.borderWidth = bw + 'px';
      f.style.borderColor = fr.color;
      f.style.boxShadow = '0 ' + (fw * 0.018) + 'px ' + (fw * 0.036) + 'px rgb(0 0 0 / .24),' +
                          '0 ' + (fw * 0.004) + 'px ' + (fw * 0.008) + 'px rgb(0 0 0 / .18)';
    }

    var art = el_('div', 'gwb-f__art');
    if (slot.product) {
      var img = el_('img', 'gwb-f__img');
      img.alt = ''; img.draggable = false;
      var tryck = tryckUrl(slot.product.sku, fw);
      if (tryck) {
        img.addEventListener('error', function pa() {
          img.removeEventListener('error', pa);
          img.src = artUrl(slot.product, fw);
        });
        img.src = tryck;
      } else {
        img.src = artUrl(slot.product, fw);
      }
      art.appendChild(img);
    } else {
      var e = el_('span', 'gwb-f__empty');
      var knapp = el_('span', 'gwb-f__plus');
      knapp.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" ' +
        'stroke="currentColor" stroke-width="2.4" stroke-linecap="round">' +
        '<path d="M12 5v14M5 12h14"/></svg>';
      e.appendChild(knapp);
      e.appendChild(el_('span', 'gwb-f__label', fw < 84 ? 'Välj' : 'Välj konstverk'));
      e.appendChild(el_('span', 'gwb-f__size', sizeLabel(slot.w, slot.h)));
      art.appendChild(e);
    }
    f.appendChild(art);
    f.appendChild(el_('span', 'gwb-f__glass'));

    var del = el_('button', 'gwb-f__del');
    del.type = 'button';
    del.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" ' +
      'stroke="currentColor" stroke-width="3" stroke-linecap="round">' +
      '<path d="M6 6l12 12M18 6L6 18"/></svg>';
    del.setAttribute('aria-label', 'Ta bort ram');
    // Ramen fångar pekaren vid pointerdown. Utan detta hamnar klicket på
    // ramen i stället för på krysset, och väljaren öppnas.
    del.addEventListener('pointerdown', function (ev) { ev.stopPropagation(); });
    del.addEventListener('click', function (ev) {
      ev.stopPropagation();
      S.slots = S.slots.filter(function (s) { return s.id !== slot.id; });
      renderWall(); save();
    });
    f.appendChild(del);

    f.addEventListener('pointerdown', onDown);
    f.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); openPicker(slot.id); return; }
      var step = ev.shiftKey ? 5 : 1;
      if (ev.key === 'ArrowLeft') { slot.x -= step; ev.preventDefault(); renderWall(); save(); }
      if (ev.key === 'ArrowRight') { slot.x += step; ev.preventDefault(); renderWall(); save(); }
      if (ev.key === 'ArrowUp') { slot.y -= step; ev.preventDefault(); renderWall(); save(); }
      if (ev.key === 'ArrowDown') { slot.y += step; ev.preventDefault(); renderWall(); save(); }
    });
    return f;
  }

  function bildbredd(cssWidth) {
    var need = cssWidth * (window.devicePixelRatio || 1);
    var steps = [300, 600, 900, 1600];
    return steps.find(function (s) { return s >= need; }) || 1600;
  }

  // Produktbilden är en mockup: verket ligger på en grå bakgrund med skugga.
  // Den duger inte inne i en ram. Tryckfilen är samma verk utan bakgrund och
  // heter <prefix><artikelnummer>.jpg, där artikelnumret är variantens SKU.
  function tryckUrl(sku, cssWidth) {
    if (!sku || !CFG.printBase) return null;
    var prefix = CFG.printPrefix != null ? CFG.printPrefix : 'tryck-';
    return CFG.printBase.replace(/\/+$/, '') + '/' + prefix + sku + '.jpg?width=' + bildbredd(cssWidth);
  }

  function skuFor(variants, w, h) {
    if (!variants) return null;
    var mal = sizeKey(w, h);
    var hit = variants.find(function (v) {
      return v.available !== false && String(v.title).replace(/\s/g, '').indexOf(mal) !== -1;
    });
    return hit && hit.sku ? String(hit.sku) : null;
  }

  function matchVariant(variants, w, h) {
    var mal = sizeKey(w, h);
    var hit = variants.find(function (v) {
      return v.available !== false && String(v.title).replace(/\s/g, '').indexOf(mal) !== -1;
    });
    return hit ? hit.id : null;
  }

  function artUrl(p, cssWidth) {
    return p.image.split('?')[0] + '?width=' + bildbredd(cssWidth);
  }

  /* ------------------------------------------------------------- dragning */

  function onDown(ev) {
    if (ev.button != null && ev.button !== 0) return;
    var node = ev.currentTarget;
    var slot = S.slots.find(function (s) { return s.id === node.dataset.id; });
    if (!slot) return;

    var m = ppc();
    var startX = ev.clientX, startY = ev.clientY;
    var origX = slot.x, origY = slot.y;
    var moved = false;

    // Vissa webblasare kastar om pekaren redan slappts nar handlaren kors.
    // Utan try hoppar resten av funktionen over och ramen gar inte att dra.
    try { node.setPointerCapture(ev.pointerId); } catch (e) {}
    node.classList.add('is-dragging');

    function move(e) {
      var dx = (e.clientX - startX) / m;
      var dy = (e.clientY - startY) / m;
      if (!moved && Math.abs(e.clientX - startX) + Math.abs(e.clientY - startY) > 4) moved = true;
      slot.x = origX + dx;
      slot.y = origY + dy;
      clampToStage(slot);
      snap(slot);
      node.style.left = (slot.x * m) + 'px';
      node.style.top = (slot.y * m) + 'px';
    }

    function up() {
      try { node.releasePointerCapture(ev.pointerId); } catch (e) {}
      node.classList.remove('is-dragging');
      clearGuides();
      node.removeEventListener('pointermove', move);
      node.removeEventListener('pointerup', up);
      node.removeEventListener('pointercancel', up);
      if (!moved) openPicker(slot.id);
      else { save(); updateSummary(); }
    }

    node.addEventListener('pointermove', move);
    node.addEventListener('pointerup', up);
    node.addEventListener('pointercancel', up);
  }

  function snap(slot) {
    clearGuides();
    var best = { x: null, y: null, dx: SNAP_CM, dy: SNAP_CM };
    var mine = {
      l: slot.x - slot.w / 2, c: slot.x, r: slot.x + slot.w / 2,
      t: slot.y - slot.h / 2, m: slot.y, b: slot.y + slot.h / 2
    };

    if (Math.abs(slot.x) < best.dx) { best.dx = Math.abs(slot.x); best.x = { to: 0, adj: 0 }; }
    if (Math.abs(slot.y) < best.dy) { best.dy = Math.abs(slot.y); best.y = { to: 0, adj: 0 }; }

    S.slots.forEach(function (o) {
      if (o.id === slot.id) return;
      var theirs = {
        l: o.x - o.w / 2, c: o.x, r: o.x + o.w / 2,
        t: o.y - o.h / 2, m: o.y, b: o.y + o.h / 2
      };
      [['l', 'l', -slot.w / 2], ['l', 'r', -slot.w / 2], ['c', 'c', 0],
       ['r', 'l', slot.w / 2], ['r', 'r', slot.w / 2]].forEach(function (p) {
        var d = Math.abs(mine[p[0]] - theirs[p[1]]);
        if (d < best.dx) { best.dx = d; best.x = { to: theirs[p[1]], adj: p[2] }; }
      });
      [['t', 't', -slot.h / 2], ['t', 'b', -slot.h / 2], ['m', 'm', 0],
       ['b', 't', slot.h / 2], ['b', 'b', slot.h / 2]].forEach(function (p) {
        var d = Math.abs(mine[p[0]] - theirs[p[1]]);
        if (d < best.dy) { best.dy = d; best.y = { to: theirs[p[1]], adj: p[2] }; }
      });
    });

    var m = ppc();
    if (best.x) { slot.x = best.x.to - best.x.adj; guide('v', best.x.to * m); }
    if (best.y) { slot.y = best.y.to - best.y.adj; guide('h', best.y.to * m); }
  }

  function guide(dir, pos) {
    var g = el_('i', 'gwb__guide gwb__guide--' + dir);
    if (dir === 'v') g.style.left = pos + 'px'; else g.style.top = pos + 'px';
    el.wall.appendChild(g);
  }

  function clearGuides() {
    el.wall.querySelectorAll('.gwb__guide').forEach(function (g) { g.remove(); });
  }

  /* ----------------------------------------------------------- väljaren */

  var pickerFor = null;
  var sokTimer = null;
  var sida = 1;
  var sisteSok = '';

  function slotNu() {
    return S.slots.find(function (s) { return s.id === pickerFor; });
  }

  function openPicker(slotId) {
    pickerFor = slotId;
    var slot = slotNu();
    if (!slot) return;
    el.picker.hidden = false;
    document.body.style.overflow = 'hidden';
    el.ptitle.textContent = slot.product ? slot.product.title : 'Välj konstverk';
    el.input.value = '';
    sisteSok = '';
    renderSizeChips();
    renderFrameChips();
    // Har kunden redan valt en kategori oppnas nasta ruta i samma kategori.
    if (S.category) {
      var vald = (CFG.categories || []).find(function (k) { return k.handle === S.category; });
      visaPosters(S.category, vald ? vald.name : null);
    } else {
      visaKategorier();
    }
  }

  function closePicker() {
    pickerFor = null;
    el.picker.hidden = true;
    document.body.style.overflow = '';
  }

  // Raderna dras i sidled i telefon. Utan detta hamnar det valda utanför
  // skärmen och det ser ut som om ingenting alls är valt.
  function visaVald(rad) {
    var v = rad.querySelector('.is-active');
    if (v && rad.scrollWidth > rad.clientWidth) {
      rad.scrollLeft = Math.max(0, v.offsetLeft - rad.clientWidth / 2 + v.offsetWidth / 2);
    }
  }

  // Storleken ändras per ruta. Varianten och tryckfilen räknas om direkt ur
  // produktens redan hämtade varianter, så inget nytt anrop behövs.
  function renderSizeChips() {
    var slot = slotNu();
    el.sizes.innerHTML = '';
    storlekar().forEach(function (sz) {
      var vald = slot.w === sz.w && slot.h === sz.h;
      var b = el_('button', 'gwb-p__chip' + (vald ? ' is-active' : ''), sizeLabel(sz.w, sz.h));
      b.type = 'button';
      b.addEventListener('click', function () {
        slot.w = sz.w; slot.h = sz.h;
        if (slot.product && slot.product.variants) {
          slot.variantId = matchVariant(slot.product.variants, sz.w, sz.h);
          slot.product.sku = skuFor(slot.product.variants, sz.w, sz.h);
        }
        clampToStage(slot);
        renderSizeChips(); renderWall(); save();
        if (!el.input.value) loadProducts('', 1, false);
      });
      el.sizes.appendChild(b);
    });
    visaVald(el.sizes);
  }

  // Ramraden i panelen satter ALLA rutor pa en gang. Varje ruta kan sedan
  // andras for sig i valjaren — det ar den raden som vinner.
  function renderFrames() {
    if (!el.frames) return;
    el.frames.innerHTML = '';

    function opt(key, namn, farg, thumb) {
      var allaLika = S.slots.length > 0 && S.slots.every(function (s) { return s.frame === key; });
      var b = el_('button', 'gwb__opt' + (allaLika ? ' is-active' : ''));
      b.type = 'button';
      if (thumb) {
        var im = document.createElement('img');
        im.src = thumb; im.alt = ''; im.loading = 'lazy';
        b.appendChild(im);
      } else {
        var sw = el_('span', 'gwb__swatch' + (key ? '' : ' gwb__swatch--none'));
        if (farg) sw.style.background = farg;
        b.appendChild(sw);
      }
      b.appendChild(el_('span', 'gwb__optlabel', namn));
      b.addEventListener('click', function () {
        S.slots.forEach(function (s) {
          // Hoppa over rutor dar ramen inte finns i den storleken
          if (key && (!CFG.frames[key].variants || !CFG.frames[key].variants[sizeKey(s.w, s.h)])) return;
          s.frame = key;
        });
        S.lastFrame = key;
        renderFrames(); renderWall(); save();
      });
      el.frames.appendChild(b);
    }

    opt(null, 'Ingen ram', null, null);
    Object.keys(CFG.frames).forEach(function (key) {
      var f = CFG.frames[key];
      opt(key, f.name, f.color, f.thumb);
    });
  }

  function renderFrameChips() {
    var slot = slotNu();
    el.framechips.innerHTML = '';

    function chip(key, namn, farg) {
      var vald = slot.frame === key;
      var b = el_('button', 'gwb-p__chip' + (vald ? ' is-active' : ''));
      b.type = 'button';
      var dot = el_('span', 'gwb-p__dot' + (key ? '' : ' gwb-p__dot--none'));
      if (farg) dot.style.background = farg;
      b.appendChild(dot);
      b.appendChild(document.createTextNode(namn));
      b.addEventListener('click', function () {
        slot.frame = key;
        S.lastFrame = key;
        renderFrameChips(); renderFrames(); renderWall(); save();
      });
      el.framechips.appendChild(b);
    }

    chip(null, 'Ingen ram', null);
    Object.keys(CFG.frames).forEach(function (key) {
      var f = CFG.frames[key];
      // Ramar som inte finns i rutans storlek går inte att välja — då skulle
      // priset bli fel och varukorgsraden sakna variant.
      if (!f.variants || !f.variants[sizeKey(slot.w, slot.h)]) return;
      chip(key, f.name, f.color);
    });
    visaVald(el.framechips);
  }

  // Forsta vyn ar kategorierna, inte en lista med posters. Kunden valjer
  // kategori och far dess verk i bastsaljarordning. Sokrutan nar hela
  // butiken hela tiden, oavsett vilken vy som visas.
  function visaKategorier() {
    var kats = CFG.categories || [];
    if (!kats.length) { visaPosters(CFG.sourceCollection, null); return; }

    el.nav.hidden = true;
    el.grid.hidden = true;
    el.catgrid.hidden = false;
    el.more.hidden = true;
    el.catgrid.innerHTML = '';

    kats.forEach(function (k) {
      var b = el_('button', 'gwb-p__cat');
      b.type = 'button';
      var im = document.createElement('img');
      im.alt = ''; im.loading = 'lazy';
      im.src = k.img || 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
      b.appendChild(im);
      b.appendChild(el_('span', null, k.name));
      b.addEventListener('click', function () { visaPosters(k.handle, k.name); });
      el.catgrid.appendChild(b);
    });
  }

  function visaPosters(handle, namn) {
    S.category = handle;
    sisteSok = '';
    el.input.value = '';
    sida = 1;
    el.catgrid.hidden = true;
    el.grid.hidden = false;
    el.nav.hidden = (CFG.categories || []).length === 0;
    el.here.textContent = namn || '';
    save();
    loadProducts('', 1, false);
  }

  function visaSokning(q) {
    sisteSok = q;
    sida = 1;
    el.catgrid.hidden = true;
    el.grid.hidden = false;
    el.nav.hidden = (CFG.categories || []).length === 0;
    el.here.textContent = 'S\u00f6kresultat';
    loadProducts(q, 1, false);
  }

  function harTagg(p) {
    if (!CFG.requireTag) return true;
    var t = p.tags;
    if (!t) return false;
    if (typeof t === 'string') t = t.split(',');
    return t.some(function (x) { return String(x).trim().toLowerCase() === CFG.requireTag.toLowerCase(); });
  }

  function loadProducts(q, vilken, lagg_till) {
    var grid = el.grid;
    grid.setAttribute('aria-busy', 'true');
    if (!lagg_till) grid.innerHTML = '';
    el.more.hidden = true;

    var handle = S.category || CFG.sourceCollection || 'all';
    var p = hamta(q, handle, vilken);

    p.then(function (items) {
      var kvar = items.length;
      items = items.filter(harTagg);
      var slot = slotNu();
      var bw = slot ? slot.w : 50, bh = slot ? slot.h : 70;

      if (!items.length && !lagg_till) {
        grid.innerHTML = '';
        grid.appendChild(el_('p', 'gwb-p__tom', 'Inga träffar'));
      }

      items.forEach(function (prod) {
        var bild = (prod.images && prod.images[0] && prod.images[0].src) || prod.image;
        if (!bild) return;
        var b = el_('button', 'gwb-p__item');
        b.type = 'button';

        // Rutan visar verket, inte mockupen, när artikelnumret finns med.
        var sku = skuFor(prod.variants, bw, bh);
        var tryck = tryckUrl(sku, 150);
        var im = document.createElement('img');
        im.alt = ''; im.loading = 'lazy';
        if (tryck) {
          im.addEventListener('error', function pa() {
            im.removeEventListener('error', pa);
            im.src = bild.split('?')[0] + '?width=300';
          });
          im.src = tryck;
        } else {
          im.src = bild.split('?')[0] + '?width=300';
        }
        b.appendChild(im);
        b.appendChild(el_('span', null, prod.title));
        b.addEventListener('click', function () { choose(prod, bild); });
        grid.appendChild(b);
      });

      el.more.hidden = kvar < 24;
      grid.setAttribute('aria-busy', 'false');
    }).catch(function () {
      if (!lagg_till) {
        grid.innerHTML = '';
        grid.appendChild(el_('p', 'gwb-p__tom', 'Kunde inte hämta konstverk'));
      }
      grid.setAttribute('aria-busy', 'false');
    });
  }

  function json(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }

  function hamta(q, handle, vilken) {
    if (!q) {
      // Egen vy: ger bastsaljarordning, taggar och artikelnummer.
      // products.json kan inte sorteras och saknar taggar.
      //
      // Reservvagen far INTE hanga pa att anropet kastar. Med
      // Accept: application/json svarar Shopify med giltig JSON aven nar
      // vyn saknas — fast utan produkter. Darfor provas formen.
      var reserv = function () {
        return json('/collections/' + handle + '/products.json?limit=24&page=' + vilken)
          .then(function (d) { return d.products || []; });
      };
      return json('/collections/' + handle + '?view=gwb&sort_by=best-selling&page=' + vilken)
        .then(function (d) {
          return Array.isArray(d.products) && d.products.length ? d.products : reserv();
        })
        .catch(reserv);
    }
    // Sökning går mot hela butiken. Den egna vyn ger taggar och artikelnummer,
    // vilket den vanliga föreslagna sökningen inte gör — utan dem går varken
    // taggfiltret eller tryckfilen att använda på ett sökresultat.
    var sok = (CFG.routes.search || '/search') + '?q=' + encodeURIComponent(q) +
              '&type=product&view=gwb&page=' + vilken;
    var reservSok = function () {
      return json('/search/suggest.json?q=' + encodeURIComponent(q) +
                  '&resources[type]=product&resources[limit]=24')
        .then(function (d) {
          return (d.resources && d.resources.results && d.resources.results.products) || [];
        });
    };
    return json(sok)
      .then(function (d) {
        return Array.isArray(d.results) && d.results.length ? d.results : reservSok();
      })
      .catch(reservSok);
  }

  function choose(p, img) {
    var slot = slotNu();
    if (!slot) return closePicker();
    fetch('/products/' + p.handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (full) {
        slot.product = {
          handle: p.handle, title: full.title, image: img,
          variants: full.variants, sku: skuFor(full.variants, slot.w, slot.h)
        };
        slot.variantId = matchVariant(full.variants, slot.w, slot.h);
        if (slot.frame == null && S.lastFrame) slot.frame = S.lastFrame;
        renderWall(); save(); closePicker();
      })
      .catch(function () { closePicker(); });
  }

  /* ------------------------------------------------------------ summering */

  function priceOf(slot) {
    var sum = 0;
    if (slot.product && slot.variantId) {
      var v = slot.product.variants.find(function (x) { return x.id === slot.variantId; });
      if (v) sum += v.price;
    }
    if (slot.frame && CFG.frames[slot.frame]) {
      var fv = CFG.frames[slot.frame].variants[sizeKey(slot.w, slot.h)];
      if (fv) sum += fv.price;
    }
    return sum;
  }

  // Mangdrabatten raknas pa ANTALET konstverk, inte pa antalet rader i
  // varukorgen. En poster med ram ar ett konstverk, inte tva.
  function rabattFor(antal) {
    var basta = 0;
    (CFG.discounts || []).forEach(function (d) {
      if (antal >= d.from && d.pct > basta) basta = d.pct;
    });
    return basta;
  }

  function updateSummary() {
    var posters = S.slots.filter(function (s) { return s.product; }).length;
    var ramar = S.slots.filter(function (s) {
      return s.frame && CFG.frames[s.frame] && CFG.frames[s.frame].variants[sizeKey(s.w, s.h)];
    }).length;
    var total = S.slots.reduce(function (a, s) { return a + priceOf(s); }, 0);

    el.count.textContent = 'Konstverk ' + posters + '/' + S.slots.length +
                           (ramar ? ' · Ramar ' + ramar : '');

    var pct = rabattFor(posters);
    if (pct > 0 && total > 0) {
      var av = Math.round(total * pct / 100);
      el.fore.textContent = kr(total);
      el.fore.hidden = false;
      el.total.textContent = kr(total - av);
      el.rabatt.textContent = '\u2212' + pct + ' %';
      el.rabatt.hidden = false;
    } else {
      el.fore.hidden = true;
      el.rabatt.hidden = true;
      el.total.textContent = kr(total);
    }

    var ext = extent(S.slots);
    el.measure.textContent = S.slots.length
      ? Math.round(ext.w) + ' × ' + Math.round(ext.h) + ' cm'
      : '';

    el.addBtn.disabled = posters === 0;
  }

  /* -------------------------------------------------------------- varukorg */

  // Antal tavlor som gar att rama in: en poster med en ram i sin storlek.
  function inramningsbara() {
    return S.slots.filter(function (s) {
      return s.product && s.variantId && s.frame && CFG.frames[s.frame] &&
             CFG.frames[s.frame].variants[sizeKey(s.w, s.h)];
    }).length;
  }

  function fragaInramning(antal) {
    var styck = CFG.framing.price;
    el.framingText.textContent = antal + (antal === 1 ? ' tavla' : ' tavlor') +
      ' \u00b7 ' + kr(styck) + ' st \u00b7 ' + kr(styck * antal) + ' totalt';
    el.framing.hidden = false;
  }

  function addToCart() {
    var klara = S.slots.filter(function (s) { return s.product && s.variantId; });
    if (!klara.length) return;

    // Fragan stalls en gang, har pa vagen till kassan. Finns ingen tjanst
    // upplagd, eller ingen tavla med ram, hoppas den over helt.
    var antalRam = inramningsbara();
    if (S.framing === null && CFG.framing && antalRam > 0) {
      fragaInramning(antalRam);
      return;
    }

    S.wallId = S.wallId || 'w' + Date.now().toString(36);
    el.addBtn.disabled = true;
    el.addBtn.textContent = 'Lägger till…';

    var posters = klara.map(function (s) {
      return {
        id: s.variantId,
        quantity: 1,
        properties: {
          _wall: S.wallId,
          _pos: Math.round(s.x) + ',' + Math.round(s.y),
          Storlek: sizeLabel(s.w, s.h)
        }
      };
    });

    post(posters)
      .then(function (res) {
        var rader = (res && res.items) || [];
        var ramar = [];
        klara.forEach(function (s, i) {
          if (!s.frame || !CFG.frames[s.frame]) return;
          var fv = CFG.frames[s.frame].variants[sizeKey(s.w, s.h)];
          if (!fv) return;
          ramar.push({
            id: fv.id,
            quantity: 1,
            properties: {
              Poster: s.product.title,
              Ram: CFG.frames[s.frame].name,
              Storlek: sizeLabel(s.w, s.h),
              _wall: S.wallId,
              _bundle_id: (rader[i] && rader[i].key) || s.variantId
            }
          });
        });
        // Inramningen laggs till en gang, med antal = antal tavlor med ram.
        if (S.framing && CFG.framing) {
          var antal = inramningsbara();
          if (antal > 0) {
            ramar.push({
              id: CFG.framing.id,
              quantity: antal,
              properties: { _wall: S.wallId }
            });
          }
        }
        return ramar.length ? post(ramar) : null;
      })
      .then(function () { window.location.href = CFG.routes.cart; })
      .catch(function () {
        el.addBtn.disabled = false;
        el.addBtn.textContent = 'Lägg väggen i varukorgen';
        el.error.textContent = 'Något gick fel. Försök igen.';
        el.error.hidden = false;
      });
  }

  function post(items) {
    return fetch(CFG.routes.cartAdd, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }

  /* ---------------------------------------------------------- beständighet */

  function save() {
    try {
      localStorage.setItem(LAGER, JSON.stringify({
        v: 2, room: S.room, color: S.color, lastFrame: S.lastFrame,
        category: S.category, framing: S.framing,
        slots: S.slots.map(function (s) {
          return {
            w: s.w, h: s.h, x: Math.round(s.x * 10) / 10, y: Math.round(s.y * 10) / 10,
            handle: s.product && s.product.handle,
            title: s.product && s.product.title,
            image: s.product && s.product.image,
            sku: s.product && s.product.sku,
            variantId: s.variantId, frame: s.frame
          };
        })
      }));
    } catch (e) { /* privat läge — strunt samma */ }
  }

  function load() {
    try {
      var d = JSON.parse(localStorage.getItem(LAGER) || 'null');
      if (!d || d.v !== 2 || !d.slots || !d.slots.length) return false;
      S.room = typeof d.room === 'number' && d.room < CFG.rooms.length ? d.room : null;
      S.color = typeof d.color === 'number' && d.color < CFG.wallColors.length ? d.color : 0;
      S.lastFrame = d.lastFrame || null;
      S.category = d.category || null;
      S.framing = typeof d.framing === 'boolean' ? d.framing : null;
      S.slots = d.slots.map(function (s) {
        return {
          id: uid(), w: s.w, h: s.h, x: s.x, y: s.y, frame: s.frame || null,
          variantId: s.variantId || null,
          product: s.handle
            ? { handle: s.handle, title: s.title, image: s.image, sku: s.sku || null, variants: [] }
            : null
        };
      });
      // Varianterna behövs för pris — hämta dem igen
      S.slots.forEach(function (s) {
        if (!s.product) return;
        fetch('/products/' + s.product.handle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (f) {
            s.product.variants = f.variants;
            if (!s.product.sku) {
              s.product.sku = skuFor(f.variants, s.w, s.h);
              if (s.product.sku) renderWall();
            }
            updateSummary();
          })
          .catch(function () {});
      });
      return true;
    } catch (e) { return false; }
  }

  /* ----------------------------------------------------------------- start */

  function init(root) {
    CFG = JSON.parse(root.querySelector('[data-gwb-config]').textContent);
    if (!CFG.wallColors.length) CFG.wallColors = [{ name: 'Benvit', color: '#f2ece3' }];

    el.root = root;
    el.stage = root.querySelector('.gwb__stage');
    el.wall = root.querySelector('.gwb__wall');
    el.rooms = root.querySelector('.gwb__rooms');
    el.colors = root.querySelector('.gwb__colors');
    el.frames = root.querySelector('.gwb__frames');
    el.picker = root.querySelector('.gwb-p');
    el.ptitle = root.querySelector('[data-gwb-ptitle]');
    el.sizes = root.querySelector('[data-gwb-sizes]');
    el.framechips = root.querySelector('[data-gwb-framechips]');
    el.catgrid = root.querySelector('[data-gwb-catgrid]');
    el.nav = root.querySelector('[data-gwb-nav]');
    el.here = root.querySelector('[data-gwb-here]');
    el.grid = root.querySelector('.gwb-p__grid');
    el.input = root.querySelector('.gwb-p__input');
    el.more = root.querySelector('[data-gwb-more]');
    el.count = root.querySelector('[data-gwb-count]');
    el.total = root.querySelector('[data-gwb-total]');
    el.fore = root.querySelector('[data-gwb-fore]');
    el.rabatt = root.querySelector('[data-gwb-rabatt]');
    el.measure = root.querySelector('[data-gwb-measure]');
    el.addBtn = root.querySelector('[data-gwb-add]');
    el.error = root.querySelector('[data-gwb-error]');
    el.framing = root.querySelector('[data-gwb-framing]');
    el.framingText = root.querySelector('[data-gwb-framing-text]');
    el.framingYes = root.querySelector('[data-gwb-framing-yes]');
    el.framingNo = root.querySelector('[data-gwb-framing-no]');

    if (!load()) startWall();
    else renderWall();

    renderRooms();
    renderColors();
    renderFrames();
    paintRoom();

    root.querySelector('[data-gwb-addframe]').addEventListener('click', function () {
      var sz = CFG.defaultSize;
      var sista = S.slots[S.slots.length - 1];
      if (sista) sz = { w: sista.w, h: sista.h };
      var gap = CFG.gapCm != null ? CFG.gapCm : 5;
      var plats = nyPlats(sz, gap);
      S.slots.push({
        id: uid(), w: sz.w, h: sz.h, x: plats.x, y: plats.y,
        product: null, variantId: null, frame: S.lastFrame
      });
      renderWall(); save();
    });

    root.querySelector('[data-gwb-reset]').addEventListener('click', function () {
      try { localStorage.removeItem(LAGER); } catch (e) {}
      S.lastFrame = null;
      S.framing = null;
      startWall();
      renderFrames();
    });

    el.addBtn.addEventListener('click', addToCart);

    el.framingYes.addEventListener('click', function () {
      S.framing = true; el.framing.hidden = true; save(); addToCart();
    });
    el.framingNo.addEventListener('click', function () {
      S.framing = false; el.framing.hidden = true; save(); addToCart();
    });

    root.querySelector('[data-gwb-close]').addEventListener('click', closePicker);
    root.querySelector('[data-gwb-back]').addEventListener('click', function () {
      S.category = null;
      el.input.value = '';
      sisteSok = '';
      save();
      visaKategorier();
    });
    el.picker.addEventListener('click', function (e) { if (e.target === el.picker) closePicker(); });
    el.input.addEventListener('input', function (e) {
      clearTimeout(sokTimer);
      var q = e.target.value.trim();
      sokTimer = setTimeout(function () {
        if (q) visaSokning(q);
        else if (S.category) visaPosters(S.category, el.here.textContent);
        else visaKategorier();
      }, 220);
    });
    el.more.addEventListener('click', function () {
      sida += 1;
      loadProducts(sisteSok, sida, true);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !el.picker.hidden) closePicker();
    });

    // Scenen är responsiv — rita om när bredden ändras, annars hamnar
    // ramarna fel eftersom px-per-cm då är inaktuell.
    new ResizeObserver(function () { renderWall(); }).observe(el.stage);
  }

  function boot() {
    document.querySelectorAll('[data-gwb]').forEach(function (r) {
      if (!r.dataset.gwbReady) { r.dataset.gwbReady = '1'; init(r); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();